import React from "react";

const CardFront = (props) => {
  return (
    <div className="front">
      <img
        className="course-logo"
        src={`/${props.courseLogoPath}`}
        alt={props.courseLogoAlt}
      />
      <img
        className="provider-logo"
        src={`/${props.providerLogoPath}`}
        alt={props.providerLogoAlt}
      />
    </div>
  );
};

export default CardFront;
